import cx from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import ReactDOM from 'react-dom';

import Button from 'components/ButtonDeprecated';
import CurrentUser from 'auth/CurrentUser';
// @ts-ignore
import DriveBy from 'lib/DriveBy';
import Electron from 'lib/Electron';
import Glyph from 'components/Glyph';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import { getGooglePlayShortLink } from 'utils/getGooglePlayLink';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import List from 'components/List';
import ModalTrigger from 'components/ModalTrigger';
// @ts-ignore
import SupportDialog from 'support/components/SupportDialog';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';

import './styles/Header.scss';

type Props = {
  location: any;
  className?: string;
} & DefaultProps;

type DefaultProps = {
  showNavigation: boolean;
};

class Header extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static defaultProps: DefaultProps = {
    showNavigation: true,
  };

  handleDriveBy = () => {
    return new DriveBy(ReactDOM.findDOMNode(this));
  };

  userIsSignedInAndExists = () => {
    return CurrentUser.isSignedIn() && CurrentUser.getUser();
  };

  renderAuthenticatedNavigation() {
    return <nav className="Header-navigation">{this.renderHelpButton()}</nav>;
  }

  renderHelpButton() {
    return (
      <List className="Header-secondaryNav" horizontal>
        <li>
          <ModalTrigger modal={<SupportDialog />}>
            <Button level="text" tooltip="Help" tooltipPlacement="bottom" aria-label="Help">
              <Glyph name="help" solo />
            </Button>
          </ModalTrigger>
        </li>
      </List>
    );
  }

  renderBrand() {
    const props = {
      className: 'Header-brandLink',
      onDragEnd: this.handleDriveBy,
    };

    const { router } = this.context;
    if (router.isActive('/setup')) {
      return <div {...props}>Remind</div>;
    }

    if (this.userIsSignedInAndExists()) {
      return (
        <Link {...props} to="/classes">
          Remind
        </Link>
      );
    } else {
      return (
        <Link
          {...props}
          href={LinkConstants.MARKETING}
          target={Electron.isAvailable() ? '_blank' : undefined}>
          Remind
        </Link>
      );
    }
  }

  renderMobileNavigation() {
    const link = userAgent.android() ? getGooglePlayShortLink() : LinkConstants.APP_DOWNLOAD;

    return (
      <nav className="Header-navigation">
        <Button className="Header-button" href={link} size="small" eventElementName="Header-button">
          Get the app
        </Button>
      </nav>
    );
  }

  renderNavigation() {
    if (this.userIsSignedInAndExists()) {
      if (userAgent.phone()) {
        return this.renderMobileNavigation();
      } else {
        return this.renderAuthenticatedNavigation();
      }
    } else {
      return this.renderUnauthenticatedNavigation();
    }
  }

  renderUnauthenticatedNavigation() {
    const { router } = this.context;

    // redirect here on authentication, unless here is the "Sign Out" page
    const skipRedirect =
      router.isActive('/log_in') ||
      router.isActive('/log_out') ||
      router.isActive('/forgot_password') ||
      router.isActive('/reset_password') ||
      router.isActive('/confirm_email') ||
      router.isActive('/confirm_added_devices') ||
      router.isActive('/send_the_app') ||
      router.isActive('/share_remind');

    const query = skipRedirect
      ? null
      : Object.assign({ locationOnAuth: this.props.location.pathname }, this.props.location.query);

    const signupTarget = Electron.isAvailable() ? '_blank' : undefined;

    // FIXME observe locationOnAuth query in "Sign up" case too.
    // Right now it requires `href` because it's in MARKETING, which has no locationOnAuth.
    const conditionalProps = router.isActive('/log_in')
      ? { children: 'Sign up', href: LinkConstants.SIGN_UP, target: signupTarget }
      : { children: 'Log in', to: { pathname: '/log_in', query } };

    return (
      <nav className="Header-navigation">
        {router.isActive('/log_in') && this.renderHelpButton()}
        <Button
          className="Header-button"
          size="small"
          {...conditionalProps}
          eventElementName="Header-button"
        />
      </nav>
    );
  }

  render() {
    return (
      <header className={cx('Header', getPropClassesFromInstance(this), this.props.className)}>
        {this.renderBrand()}
        {this.props.showNavigation ? this.renderNavigation() : null}
      </header>
    );
  }
}

export default Header;
